import { useState } from 'react';
import WalkingLog from './WalkingLog';

// Two tabs, not four: a walk is logged after the fact, so there is no live
// runner and no templates. History is Phase 4 and renders a placeholder.
const TABS = [
  { key: 'log', label: 'Log' },
  { key: 'history', label: 'History' },
];

// Same class reuse as LiftingModule: the Swimming-* tab styling is generic in
// everything but name, and de-leaking the names is a separate refactor.
function WalkingModule({ getToken, userEmail }) {
  const [tab, setTab] = useState('log');

  return (
    <div className="Swimming">
      <div className="Swimming-tabs">
        {TABS.map(t => (
          <button
            key={t.key}
            className={`Swimming-tab${tab === t.key ? ' Swimming-tab--active' : ''}`}
            onClick={() => setTab(t.key)}
          >
            {t.label}
          </button>
        ))}
      </div>
      {tab === 'log' && <WalkingLog getToken={getToken} userEmail={userEmail} />}
      {tab === 'history' && <div className="Fitness-empty">Walking history — coming in Phase 4</div>}
    </div>
  );
}

export default WalkingModule;
